<button type="button" class="input-group-text btn btn-info" (click)="onResetButtonClicked()" [ladda]="isBusy" [disabled]="isDisabled">
    <i class="fa-solid fa-rotate-left"></i>
</button>
